import { faCheck, faMinus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import PropTypes from "prop-types";

import styles from "./Checkbox.module.scss";

const Checkbox = ({
  id,
  testId,
  label,
  checked,
  disabled,
  isDisabledUnchecked,
  partial,
  onCheck,
  onUncheck,
  onChange,
  className,
  checkboxClassName,
  containerClassName,
  labelClassName,
}) => {
  const onClick = () => {
    if (checked) {
      onChange({
        target: {
          checked: false,
        },
      });

      onUncheck();
    }

    if (!checked) {
      onChange({
        target: {
          checked: true,
        },
      });

      onCheck();
    }
  };

  const handleCheckBoxClick = (e) => {
    e.stopPropagation();

    if (!disabled) {
      onClick();
    }
  };

  const getIconTestId = () => {
    if (partial) {
      return "minus-icon";
    }

    if (checked) {
      return "check-icon";
    }

    return "uncheck-icon";
  };

  return (
    <div
      className={cx(styles.checkboxContainer, containerClassName)}
      id={id || undefined}
      data-testid={testId || "checkbox"}
    >
      <div
        className={cx(
          styles.checkbox,
          {
            [styles.checkboxUnchecked]: !checked,
            [styles.checkboxDisabled]: disabled,
          },
          className
        )}
      >
        <div
          data-testid="checkbox-target"
          className={cx(styles.checkboxTarget, checkboxClassName, {
            [styles.checkboxNoCursor]: disabled,
          })}
          onClick={handleCheckBoxClick}
          aria-hidden="true"
        />

        {!(disabled && isDisabledUnchecked) && (
          <FontAwesomeIcon
            data-testid={getIconTestId()}
            className={cx(styles.checkboxTick, { [styles.checkboxTickHidden]: !checked })}
            icon={partial ? faMinus : faCheck}
          />
        )}
      </div>
      {label && (
        <div className={cx(labelClassName)} data-testid="checkbox-label">
          {label}
        </div>
      )}
    </div>
  );
};

Checkbox.defaultProps = {
  id: undefined,
  testId: undefined,
  checked: undefined,
  disabled: false,
  partial: false,
  className: "",
  checkboxClassName: "",
  labelClassName: "",
  onCheck: () => {
    //
  },
  onUncheck: () => {
    //
  },
  onChange: () => {
    //
  },
  label: null,
  isDisabledUnchecked: false,
  containerClassName: "",
};

Checkbox.propTypes = {
  id: PropTypes.string,
  testId: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  partial: PropTypes.bool,
  className: PropTypes.string,
  checkboxClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  onCheck: PropTypes.func,
  onUncheck: PropTypes.func,
  onChange: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  isDisabledUnchecked: PropTypes.bool,
  containerClassName: PropTypes.string,
};

export default Checkbox;
